import request from "@/utils/request";

export const getReceiveList = (hqPackingListId: string) =>
  request({
    url: `/hq-packing-list/${hqPackingListId}/receive-lists`,
    method: "GET"
  });
